// extracted by mini-css-extract-plugin
export var icon = "social-module--icon--M+i0z";
export var icon_small = "social-module--icon_small--C1nhu";
export var map = "social-module--map--Y8OzW";